import { createContext, useContext, useState, useEffect } from 'react';
import { authService, profileService } from '../services/api';
import i18n from '../i18n';
import PageLoader from '../components/ui/PageLoader';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (authService.isLoggedIn()) {
            profileService.get()
                .then(response => {
                    setUser(response.data);
                    const lang = response.data?.language;
                    if (lang && ['en', 'fr'].includes(lang)) {
                        i18n.changeLanguage(lang);
                        localStorage.setItem('language', lang);
                    }
                })
                .catch(() => authService.logout())
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        const response = await authService.login(email, password);
        const profile = await profileService.get();
        setUser(profile.data);
        const lang = profile.data?.language;
        if (lang && ['en', 'fr'].includes(lang)) {
            i18n.changeLanguage(lang);
            localStorage.setItem('language', lang);
        }
        return response;
    };

    const googleLogin = async (credential, language = 'en') => {
        const response = await authService.googleLogin(credential, language);
        const profile = await profileService.get();
        setUser(profile.data);
        const lang = profile.data?.language;
        if (lang && ['en', 'fr'].includes(lang)) {
            i18n.changeLanguage(lang);
            localStorage.setItem('language', lang);
        }
        return response;
    };

    const logout = () => {
        setUser(null);
        authService.logout();
    };

    if (loading) return <PageLoader />;

    return (
        <AuthContext.Provider value={{ user, setUser, login, googleLogin, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}